import React from 'react';
import { Flex, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components';

export const formatMovementMonth = (date) =>
  new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  });

export const MovementDateRenderer = ({ data }) => {
  const { colors } = useTheme();
  const movement = data?.original;

  if (movement?.isSkeleton) {
    return (
      <ContentLoader
        speed={2}
        width={400}
        height={48}
        viewBox="0 0 400 48"
        backgroundColor={colors.neutral[50]}
        foregroundColor={colors.neutral[20]}
      >
        <rect x="8" y="16" rx="3" ry="3" width="80" height="12" />
      </ContentLoader>
    );
  }

  if (!movement?.date) {
    return (
      <Flex p="8px" alignItems="center" sx={{ height: '100%' }}>
        <Text fontSize="14px" color="text.subtle">
          -
        </Text>
      </Flex>
    );
  }

  const formattedDate = formatMovementMonth(movement.date);

  return (
    <Flex p="8px" alignItems="center" sx={{ height: '100%' }}>
      <Text fontSize="14px">{formattedDate}</Text>
    </Flex>
  );
};

MovementDateRenderer.propTypes = {
  data: PropTypes.object,
};

MovementDateRenderer.defaultProps = {
  data: {},
};
